import React from "react";
import { Buffer } from "buffer";

//Core Components
import MDCButton from "../core/MDCButton";
import MDCBrowseFile from "../core/MDCBrowseFile";
import MDCLabel from "../core/MDCLabel";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import ErrorText from "./ErrorText";

// Helpers
import { getFileExtension } from "../../helpers/fileExtension";
import { getBase64String } from "../../helpers/utils";

// Material UI
import Grid from "@mui/material/Grid";
import { withStyles } from "@mui/styles";

// Icon Components
import FileUploadIcon from "../iconComponents/FileUploadIcon";
import DiscardIcon from "../iconComponents/DiscardIcon";
import DownloadFileIcon from "../iconComponents/DownloadFileIcon";

// Constants
import {
  ZIP_FILE_VAILADATION,
  FILE_SIZE_VALIDATION_20MB,
} from "../../constants/ManualRequestFormConstants";

const styles = () => ({
  fileNameCSS: {
    marginLeft: "1rem",
  },
  fileGridCSS: {
    cursor: "pointer",
  },
});

class MDCDocumentUpload extends React.Component {
  constructor(props) {
    super(props);
    this.inputElement = React.createRef();

    // Set the initial values
    this.state = {
      openLoschenPopup: false,
      ALLOWED_EXTENSIONS: ["zip"],
      errorMessage: "" || props?.error,
      fileName: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      this.setState({
        errorMessage: this.props?.error,
      });
    }
  }

  handleFiles = (event) => {
    const fileData = event.target?.files[0];
    const fileName = event.target?.files[0]?.name;
    const allowedExtensions = this.props.allowedExtensions || ["zip"];
    const maxFileSize = this.props.maxFileSize || 20971520;

    let errorMessage = "";
    if (allowedExtensions.indexOf(getFileExtension(fileName)) === -1) {
      errorMessage = this.props.invalidFileError || ZIP_FILE_VAILADATION;
      this.setState({
        errorMessage: errorMessage,
      });
    } else if (fileData.size > maxFileSize) {
      errorMessage = this.props.fileSizeError || FILE_SIZE_VALIDATION_20MB;
      this.setState({
        errorMessage: errorMessage,
      });
    } else {
      //Converting Blob data in base 64 encoded string to send it as a json object in Axios API call
      let base64File = "";
      getBase64String(fileData).then((resp) => {
        base64File = resp.substring(resp.indexOf(",") + 1);

        errorMessage = !base64File ? errorMessage : "";

        const fileEventObj = {
          target: {
            name: fileName,
            value: base64File,
          },
        }; //Setting same event attribute like others to use it in handleChange of Manual Request for halter Request form Data

        this.setState({ fileName, errorMessage });
        this.props.handleChange(fileEventObj);
      });
    }
  };

  downloadDocumentFile = () => {
    const base64DecodedData = Buffer.from(
      this.props?.uploadedFileData,
      "base64"
    );
    const documentBlobData = new Blob([base64DecodedData], {
      type: "application/octet-stream",
    });
    const documentBlobDataURL = URL.createObjectURL(documentBlobData);
    const link = document.createElement("a");
    link.href = documentBlobDataURL;
    link.setAttribute("download", `${this.state?.fileName}`);
    document.body.appendChild(link);
    link.click();
  };

  deleteUploadedFile = () => {
    this.props.handleChange({
      target: {
        name: this.state?.fileName,
        value: "",
      },
    });
    this.setState({ openLoschenPopup: false });
  };

  render() {
    return (
      <>
        {this.props.uploadedFileData ? (
          <Grid
            container
            marginY=".5rem"
            className={this.props?.classes?.fileGridCSS}
            spacing={4}
          >
            <Grid item display="flex" alignItems="center" marginY={".5rem"}>
              <Grid onClick={this.downloadDocumentFile}>
                <DownloadFileIcon color="#00C4DE" />
              </Grid>
              <Grid className={this.props?.classes?.fileNameCSS}>
                <MDCLabel
                  label={`${this.props?.documentName} ${
                    this.props?.isShowUploadedLabel ? "hochgeladen" : ""
                  }`}
                  isReadOnly
                />
              </Grid>
            </Grid>
            <Grid item textAlign="end">
              {this.props.isDetailDialog && (
                <MDCButton
                  variant="outlined"
                  label={"Löschen"}
                  onClick={() => this.setState({ openLoschenPopup: true })}
                  endIcon={<DiscardIcon color="#00C4DE" />}
                />
              )}
            </Grid>
            {/* <ErrorText
              id={this.props?.documentName}
              error={this.state?.errorMessage}
            /> */}
          </Grid>
        ) : (
          <Grid container flexDirection={"column"} marginY=".5rem">
            {this.props?.isDetailDialog && (
              <>
                <MDCButton
                  variant="outlined"
                  documentName={this.props.documentName}
                  label={this.props?.documentName}
                  endIcon={<FileUploadIcon />}
                  onClick={() => this.inputElement.click()}
                />
                <MDCBrowseFile
                  acceptFileFormats={this.props?.acceptFileFormats || ".zip"}
                  inputRef={(input) => (this.inputElement = input)}
                  onChange={(e) => this.handleFiles(e)}
                />
              </>
            )}
            {/* {!this.props.uploadedFileData && (
              <ErrorText
                id={this.props?.documentName}
                error={this.state?.errorMessage}
              />
            )} */}
          </Grid>
        )}

        <ErrorText
          id={this.props?.documentName}
          error={this.state?.errorMessage}
        />
        <DeleteConfirmationDialog
          show={this.state.openLoschenPopup}
          handlePopupClose={() => this.setState({ openLoschenPopup: false })}
          handlePopupSubmit={this.deleteUploadedFile}
          headerTitle={"Upload löschen"}
          confirmationMessage={
            "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?"
          }
        />
      </>
    );
  }
}

export default withStyles(styles)(MDCDocumentUpload);
